export default __webpack_public_path__ + "static/media/message-of-dra.a881584d.mp4";